exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-6c95fb9e]{height:500px;padding:24px}input[data-v-6c95fb9e],select[data-v-6c95fb9e],textarea[data-v-6c95fb9e]{border:1px solid #ddd;padding:4px 8px;border-radius:4px;max-width:100%}select[data-v-6c95fb9e]{margin-right:8px}textarea[data-v-6c95fb9e]{margin-top:12px;width:100%}.label[data-v-6c95fb9e]{font-size:13px;margin-bottom:4px}", ""]);

// exports
